import {AuthState, UserAuthData} from '../stores/auth/reducers/auth.reducer';
import {LoginFormData} from '../../features/login/@types';
import {LINGUE} from './_types';
import * as moment from 'moment';

// ENABLED DB NAME
export const DB_NAMES = ['pokervasto','adriatica'];

// Permessi utenti
export const ROLE_USER = 'user';
export const ROLE_OPERATORE = 'operatore';
export const ROLE_ADMIN = 'admin';

// Lingue attive
export const LINGUA_ITALIANO = 'Italiano';
export const LINGUA_INGLESE = 'Inglese';
export const TIPI_LINGUE: LINGUE[] = [LINGUA_ITALIANO, LINGUA_INGLESE];


// URL KEY
export const MAIN_URL_REDIRECT = '/home';
export const LOGIN_URL_REDIRECT = '/login';

// STORAGE KEY
export const STORE_AUTH_KEY = 'AUTH';
export const STORE_DB_NAME_KEY = 'DB_NAME';

export const initialUserAuthData: UserAuthData = {
  id: null,
  Nome: '',
  Cognome: '',
  Alias: '',
  Telefono: '',
  Email: '',
  DataDiNascita: '',
  Username: '',
  role: null,
  DB_Name: '',
  Token: '',
  UltimoAccesso: null,
  UltimoLogin: null,
  Lingua: 'Italiano'
};

export const initialLoginFormData: LoginFormData = {username: '', password: '', rememberMe: true, dbName: ''};

export const initialAuthState: AuthState = {
  loading: false,
  isAuthenticated: false,
  loginFormData: initialLoginFormData,
  userAuthData: initialUserAuthData,
  anniTornei: [moment().format('YYYY')],
};
